import storeFileService from './store-file-service'

const baseUrl = '/api/customer/post-file'

export default {
    store: (opts) => {
        return storeFileService.store(opts, baseUrl)
    },
    update: (id, updates, options, config) => {
        return storeFileService.update(updates, options, `${baseUrl}/${id}`, config)
    },
    get: (id, options, config) => {
        return storeFileService.get(`${baseUrl}/${id}`, options, config)
    }
}
